export interface Channel {
  id: string;
  channel_id: string;
  organization_id: string;
  channel_friendly_name: string;
  channel_participants: ChannelParticipants[];
  created_at: string;
  updated_at: string;
}

export interface ChannelParticipants{
    user_id: string;
    name: string;
    is_active_on_channel: boolean;
  has_left_channel?: boolean;
    unique_reference_id?: string;
    unread_count?: number | 0;
    last_read_message_id?: string | null;
    last_read_at?: string | null;

}

export interface ChannelState {
  data:Channel | null;
  allData: Channel[] | null;
  error: string | null;
  message: string | null;
  success: boolean;
  validationError: any[];
}

export interface ChannelCreate {
  channel_friendly_name: string;
  channel_participants: ChannelParticipants[];
}

export interface ChannelMessageMarkRead {
    channel_id: string;
    last_read_message_id: string;
}

export interface ChannelLeaveRequest {
  channel_id: string;
}

export interface ChannelAddParticipantRequest {
  channel_id: string;
  user_id: string;
}

export interface ChannelRenameRequest {
  channel_id: string;
  channel_friendly_name: string;
}

export function isChannelParticipantActive(participant: ChannelParticipants): boolean {
  if (participant.has_left_channel === true) {
    return false;
  }

  return participant.is_active_on_channel !== false;
}
